import { render, staticRenderFns } from "./SpecialStudentLayout.vue?vue&type=template&id=1ee3094a"
import script from "./SpecialStudentLayout.vue?vue&type=script&lang=js"
export * from "./SpecialStudentLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports